export default __webpack_public_path__ + "static/media/status-idle.91586455.svg";